import { moveToFulfilled } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { AllCampaignsLoadFulfilledAction } from '../../domains/allCampaigns/loadActions.types';
import type { CampaignsListLoadMoreFulfilledAction } from '../../domains/allCampaigns/loadMoreAllCampaignsActions.types';
import type { CampaignCreateFulfilledAction } from '../../domains/campaignCreation/actions.types';
import type {
  CampaignEditFulfilledAction,
  CampaignPublishFulfilledAction,
} from '../../domains/campaignEdit/actions.types';
import type { CampaignLoadFulfilledAction } from '../../domains/campaigns/actions.types';
import type { MyLeaderSponsoredCampaignsLoadFulfilledAction } from '../../domains/myLeaderSponsoredCampaigns/actions.types';

import type { CampaignSponsorsEntities } from './types';

export type CampaignSponsorsAction =
  | CampaignCreateFulfilledAction
  | CampaignLoadFulfilledAction
  | CampaignEditFulfilledAction
  | CampaignPublishFulfilledAction
  | MyLeaderSponsoredCampaignsLoadFulfilledAction
  | AllCampaignsLoadFulfilledAction
  | CampaignsListLoadMoreFulfilledAction;

const initialState: CampaignSponsorsEntities = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<CampaignSponsorsEntities, CampaignSponsorsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CAMPAIGN.CREATE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignSponsors);
    case 'CAMPAIGN.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignSponsors);
    case 'CAMPAIGN.EDIT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignSponsors);
    case 'CAMPAIGN.PUBLISH_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignSponsors);
    case 'MY_LEADER_SPONSORED_CAMPAIGNS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignSponsors);
    case 'ALL_CAMPAIGNS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignSponsors);
    case 'ALL_CAMPAIGNS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.campaignSponsors);
    default:
      return state;
  }
};

export default reducer;
